import React from 'react';
import { IconSvgProps } from '@models/common';

const ChartArcs: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13184_545)'>
        <path
          d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
          stroke='#DC362E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.9241 11.1321C16.7524 10.1582 16.2958 9.25704 15.612 8.54265C14.9282 7.82825 14.0479 7.33267 13.0825 7.11858C12.117 6.90449 11.1097 6.9815 10.188 7.33987C9.26635 7.69825 8.47163 8.32189 7.90437 9.13193C7.33712 9.94198 7.02281 10.902 7.00119 11.8907C6.97958 12.8794 7.25163 13.8523 7.78294 14.6863C8.31425 15.5204 9.08096 16.1782 9.98611 16.5765C10.8913 16.9748 11.8942 17.0958 12.8681 16.9241'
          stroke='#0DB49C'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3 12C3 13.78 3.52784 15.5201 4.51677 17.0001C5.50571 18.4802 6.91131 19.6337 8.55585 20.3149C10.2004 20.9961 12.01 21.1743 13.7558 20.8271C15.5016 20.4798 17.1053 19.6226 18.364 18.364C19.6226 17.1053 20.4798 15.5016 20.8271 13.7558C21.1743 12.01 20.9961 10.2004 20.3149 8.55585C19.6337 6.91131 18.4802 5.50571 17.0001 4.51677C15.5201 3.52784 13.78 3 12 3'
          stroke='#DC362E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_13184_545'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChartArcs;
